import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Box,
} from "@mui/material";
import {
  Button,
  Datagrid,
  ReferenceManyField,
  TextField,
  DateField,
  NumberField,
  FunctionField,
  Pagination,
} from "react-admin";
import HistoryIcon from "@mui/icons-material/History";
import { ScmAnalyses } from "../types";
import LaunchIcon from "@mui/icons-material/Launch";
import { Link } from "react-router-dom";

const ScmHistoryDialog = ({ sku }: { sku: number }) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleClick = (event?: React.MouseEvent) => {
    event?.stopPropagation();
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Button
        onClick={handleClick}
        onMouseDown={(event) => event.stopPropagation()}
        sx={{
          margin: 0,
          padding: 0,
          minWidth: "auto",
        }}
      >
        <HistoryIcon />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create post"
        maxWidth="md"
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Box flex={1} mr={{ sm: "0.5em" }}>
              Histórico Produto {sku}
            </Box>
            <Box>
              <Button
                label="Ver Todos"
                component={Link}
                to={`/scmprojectionlogs?filter={"codigo_sku":${sku}}`}
                target="_blank"
                alignIcon="right"
              >
                <LaunchIcon />
              </Button>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack display={{ md: "block", lg: "flex" }}>
            <ReferenceManyField
              // target="codigo_sku"
              target="ignorar" // Nome inválido para evitar o filtro, é obrigatório passar (componente)
              reference="scmprojectionlogs"
              sort={{ field: "id", order: "DESC" }}
              filter={{ codigo_sku: sku }}
            >
              <Datagrid bulkActionButtons={false}>
                <DateField
                  source="data_hora"
                  showTime
                  label="Data/Hora"
                  fontSize="small"
                />
                <FunctionField<ScmAnalyses>
                  label="Empresa"
                  sortBy="id_empresa"
                  render={(record) => (
                    <div>
                      <NumberField
                        source="id_empresa"
                        fontSize="small"
                        options={{
                          useGrouping: false,
                        }}
                      />
                      {record?.nome_reduzido ? ". " : ""}
                      <TextField source="nome_reduzido" fontSize="small" />
                    </div>
                  )}
                />
                <NumberField source="nova_expo" label="Expo" fontSize="small" />
                <NumberField source="nova_sazo" label="Sazo" fontSize="small" />
                <NumberField source="nova_camp" label="Camp" fontSize="small" />
                <NumberField
                  source="novo_esmin"
                  fontSize="small"
                  label="ESMin"
                />
                <NumberField
                  source="novo_cmmf_quantidade"
                  fontSize="small"
                  label="CMMF"
                />
                <DateField source="novo_cmmf_validade" label="CMM Validade" />
                <TextField
                  source="nome_usuario"
                  label="Usuário"
                  fontSize="small"
                />
              </Datagrid>
              <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </ReferenceManyField>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button label="Cancelar" onClick={handleCloseClick} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ScmHistoryDialog;
